import { BookType } from 'blooksy-backend';
import { bookTypeData } from '../config';

export const generateTitle = (userName: string, bookType: BookType) => {
  const isBook = bookType !== 'dissertation' && bookType !== 'apa';

  return `${userName}'s ${bookTypeData.find(el => el.type === bookType)?.name} ${isBook ? 'Book' : ''}`;
};
